import { UIElements } from '@ansvar-sakerhet/ui';
import styled from 'styled-components';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

const Overlay = styled(AlertDialog.Overlay)`
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 200;
  display: grid;
  position: fixed;
  place-items: center;
  inset: 0;
`;

const Wrapper = styled(AlertDialog.Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
  min-width: 400px;
  max-width: 500px;
  padding: 30px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  gap: 8px;
`;

export const S = {
  ...UIElements,
  Overlay,
  Wrapper,
  ContentContainer,
  ButtonContainer,
};
